<script>
  import api from '../api'

  export default {
    data () {
      return {
        state: ''
      }
    },

    props: ['address'],

    methods: {
      async send () {
        this.state = 'sending'

        try {
          let response = await api.apios.get(`/api/notify/${this.address.id}`)
          this.state = 'sent'
        }
        catch (err) {
          this.state = 'error'
        }
      }
    }
  }
</script>
<template>
  <a @click="send" class="button is-primary" :class="{ 'is-loading': state === 'sending' }">
    <span class="icon is-small">
      <i class="fa" :class="{ 'fa-check': state === 'sent', 'fa-envelope': state === '', 'fa-times': state === 'error' }"></i>
    </span>
    <span>Send Client Notification</span>
  </a>
</template>